import { combineReducers } from 'redux';

import appsListReducer from '../features/appsList/appsListReducer';
import appDetailsReducer from '../features/appDetails/appDetailsReducer';
import appStatusFormReducer from '../features/appStatusForm/appStatusFormReducer';
import appSettingsReducer from '../features/appSettings/appSettingsReducer';
import appUrlReducer from '../features/appUrl/appUrlReducer';
import appSuggestionReducer from '../features/appSuggestion/appSuggestionReducer';
import appRemoveReducer from '../features/appRemove/appRemoveReducer';
import userReducer from '../features/user/userReducer';
import notificationReducer from '../features/notification/notificationReducer';
import sideloadReducer from '../features/sideload/sideloadReducer';
import appFeedbackReducer from '../features/appFeedback/appFeedbackReducer';
import lifecycleReducer from '../features/lifecycleReactors/lifecycleReducer';
import editorsReducer from '../features/editors/editorsReducer';

const createRootReducer = () =>
    combineReducers({
        lifecycle: lifecycleReducer,
        appsList: appsListReducer,
        appDetails: appDetailsReducer,
        appStatusForm: appStatusFormReducer,
        appSettings: appSettingsReducer,
        appUrl: appUrlReducer,
        appSuggestion: appSuggestionReducer,
        appRemove: appRemoveReducer,
        user: userReducer,
        notification: notificationReducer,
        sideload: sideloadReducer,
        appFeedback: appFeedbackReducer,
        editors: editorsReducer,
    });

export default createRootReducer;
